/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { TemplateInstanceCancellationDialogContainer as TemplateInstanceCancellationDialog } from './TemplateInstanceCancellationDialog.container';
